import { CircularProgress } from '@mui/material';
import React from 'react';

const LoaderComponent = () => {
    return (<div className="loader-overlay">
        <CircularProgress size="3rem" color='primary' />
        {/* <GradientCircularProgress /> */}
        {/* <LinearProgress /> */}
    </div>)
}

export default LoaderComponent;